import type {
	Reflection,
	FilterOptions,
	ReflectionStats,
	StatusFilter,
	SortOption,
} from "./types";

export const filterReflections = (
	reflections: Reflection[],
	searchTerm: string,
	statusFilter: StatusFilter,
): Reflection[] => {
	let filtered = [...reflections];

	// Filter by search term
	if (searchTerm) {
		const term = searchTerm.toLowerCase();
		filtered = filtered.filter(
			(reflection) =>
				reflection.title.toLowerCase().includes(term) ||
				reflection.description.toLowerCase().includes(term) ||
				reflection.topic_tags?.some((tag) => tag.toLowerCase().includes(term)),
		);
	}

	// Filter by status
	switch (statusFilter) {
		case "active":
			filtered = filtered.filter((r) => !r.archived);
			break;
		case "completed":
			filtered = filtered.filter((r) => !r.is_draft && !r.archived);
			break;
		case "draft":
			filtered = filtered.filter((r) => r.is_draft && !r.archived);
			break;
		case "archived":
			filtered = filtered.filter((r) => r.archived);
			break;
		// "all" case - no filtering needed
	}

	return filtered;
};

export const sortReflections = (
	reflections: Reflection[],
	sortBy: SortOption,
): Reflection[] => {
	return [...reflections].sort((a, b) => {
		switch (sortBy) {
			case "newest":
				return (
					new Date(b.updated_at).getTime() - new Date(a.updated_at).getTime()
				);
			case "oldest":
				return (
					new Date(a.updated_at).getTime() - new Date(b.updated_at).getTime()
				);
			case "title":
				return a.title.localeCompare(b.title);
			default:
				return 0;
		}
	});
};

export const calculateStats = (reflections: Reflection[]): ReflectionStats => {
	return {
		active: reflections.filter((r) => !r.is_draft && !r.archived).length,
		drafts: reflections.filter((r) => r.is_draft && !r.archived).length,
		archived: reflections.filter((r) => r.archived).length,
		total: reflections.length,
	};
};
